import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import { toast } from "react-toastify";
import { showAlert } from "../../common/sweetalert/sweetalert";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import { formatDateAndTime } from "../../../resources/constants";

const PASSPORT_BASE = "https://kadpolyodfel.ng/assets/passport/";
const FALLBACK_IMG = "https://kadpolyodfel.ng/assets/passport/avatar.png";

function StudentIdCardReport(props) {
    const [IsLoading, setIsLoading] = useState(true);
    const [IsActionLoading, setIsActionLoading] = useState(false);
    const [recordList, setRecordList] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const header = [
        "S/N", "AppID", "StudentID", "Student Name", "Gender",
        "Blood Group", "NIN", "Programme", "Status", "Inserted By", "Date", "Action",
    ];

    useEffect(() => {
        getData();
    }, [""]);

    const getData = async () => {
        await axios
            .get(`${serverLink}staff/registration/registration/student/id-card-processing`)
            .then((result) => {
                setRecordList(result.data);
                setIsLoading(false);
            })
            .catch(() => {
                console.log("NETWORK ERROR");
                setIsLoading(false);
            });
    };

    const markCompleted = async (AppID) => {
        setIsActionLoading(true);
        await axios
            .patch(`${serverLink}staff/registration/registration/student/id-card-processing/complete`, {
                AppID,
                UpdatedBy: props.loginData[0]?.StaffID,
            })
            .then((result) => {
                if (result.data.message === "success") {
                    toast.success("Status updated to Completed successfully");
                    getData();
                } else {
                    showAlert("ERROR", "Something went wrong. Please try again!", "error");
                }
                setIsActionLoading(false);
            })
            .catch(() => {
                setIsActionLoading(false);
                showAlert("NETWORK ERROR", "Please check your connection and try again!", "error");
            });
    };

    const showTable = () => {
        try {
            return recordList.map((item, index) => {
                const isCompleted = item.Status === "Completed";
                const statusClass = isCompleted ? "text-success" : "text-warning";
                return (
                    <tr key={index}>
                        <td className="text-xs font-weight-bold">{index + 1}</td>
                        <td className="text-xs font-weight-bold">{item.AppID}</td>
                        <td className="text-xs font-weight-bold">{item.StudentID}</td>
                        <td className="text-xs font-weight-bold">{item.StudentName}</td>
                        <td className="text-xs font-weight-bold">{item.GENDER || "N/A"}</td>
                        <td className="text-xs font-weight-bold">{item.BLOOD_GROUP || "N/A"}</td>
                        <td className="text-xs font-weight-bold">{item.NIN || "N/A"}</td>
                        <td className="text-xs font-weight-bold">{item.Programme}</td>
                        <td className={`text-xs font-weight-bold ${statusClass}`}>{item.Status}</td>
                        <td className="text-xs font-weight-bold">{item.InsertedBy}</td>
                        <td className="text-xs font-weight-bold">
                            {item.InsertedDate ? formatDateAndTime(item.InsertedDate, "date") : "N/A"}
                        </td>
                        <td className="text-xs font-weight-bold">
                            <div className="d-flex gap-1">
                                <button
                                    className="btn btn-info btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-student-details"
                                    onClick={() => setSelectedRecord(item)}
                                >
                                    View
                                </button>
                                {isCompleted ? (
                                    <span className="badge bg-success align-self-center">Completed</span>
                                ) : (
                                    <button
                                        className="btn btn-success btn-sm"
                                        disabled={IsActionLoading}
                                        onClick={() => markCompleted(item.AppID)}
                                    >
                                        Complete
                                    </button>
                                )}
                            </div>
                        </td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    const passportSrc = selectedRecord?.PICTURE
        ? `${PASSPORT_BASE}${selectedRecord.PICTURE}`
        : FALLBACK_IMG;

    return IsLoading ? (
        <div className="container-xl" style={{ height: "700px" }}>
            <div className="page-header d-print-none">
                <DataLoader />
            </div>
        </div>
    ) : (
        <>
            <div className="container-xl">
                <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="page-pretitle"></div>
                            <h2 className="page-title">Student ID Card Processing Report</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-deck row-cards">
                        <div className="col-lg-12">
                            <div className="row row-cards">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">Student ID Card Processing Report</h3>
                                            <DataTable
                                                header={header}
                                                body={showTable()}
                                                title="Student ID Card Processing Report"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Student Details Modal */}
            <div className="modal modal-blur fade" id="modal-student-details" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Student ID Card Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            {selectedRecord && (
                                <div className="row">
                                    {/* Passport Photo */}
                                    <div className="col-md-3 text-center mb-3">
                                        <img
                                            src={passportSrc}
                                            alt="Passport"
                                            className="img-thumbnail"
                                            style={{ width: "150px", height: "180px", objectFit: "cover" }}
                                            onError={(e) => { e.target.src = FALLBACK_IMG; }}
                                        />
                                        <div className="mt-2">
                                            <span className={`badge ${selectedRecord.Status === "Completed" ? "bg-success" : "bg-warning"}`}>
                                                {selectedRecord.Status}
                                            </span>
                                        </div>
                                        <a
                                            href={passportSrc}
                                            download={`${selectedRecord.StudentID || selectedRecord.AppID}-passport.jpg`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-outline-primary mt-2 w-100"
                                        >
                                            Download Photo
                                        </a>
                                    </div>

                                    {/* Student Info */}
                                    <div className="col-md-9">
                                        <div className="row">
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Full Name</label>
                                                <p className="fw-bold mb-1">{selectedRecord.StudentName || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Student ID</label>
                                                <p className="fw-bold mb-1">{selectedRecord.StudentID || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Application ID</label>
                                                <p className="fw-bold mb-1">{selectedRecord.AppID || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Programme</label>
                                                <p className="fw-bold mb-1">{selectedRecord.Programme || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Gender</label>
                                                <p className="fw-bold mb-1">{selectedRecord.GENDER || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Blood Group</label>
                                                <p className="fw-bold mb-1">{selectedRecord.BLOOD_GROUP || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>NIN</label>
                                                <p className="fw-bold mb-1">{selectedRecord.NIN || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Date of Birth</label>
                                                <p className="fw-bold mb-1">
                                                    {selectedRecord.DOB ? formatDateAndTime(selectedRecord.DOB, "date") : "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Email</label>
                                                <p className="fw-bold mb-1">{selectedRecord.EMAIL || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Phone</label>
                                                <p className="fw-bold mb-1">{selectedRecord.TELEPHONE || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Admission Year</label>
                                                <p className="fw-bold mb-1">{selectedRecord.ADMISSION_YEAR || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Admission Session</label>
                                                <p className="fw-bold mb-1">{selectedRecord.ADMISSION_SESSION || "N/A"}</p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Date Submitted</label>
                                                <p className="fw-bold mb-1">
                                                    {selectedRecord.InsertedDate ? formatDateAndTime(selectedRecord.InsertedDate, "date") : "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label text-muted mb-0" style={{ fontSize: "0.75rem" }}>Submitted By</label>
                                                <p className="fw-bold mb-1">{selectedRecord.InsertedBy || "N/A"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                            {selectedRecord && selectedRecord.Status !== "Completed" && (
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    disabled={IsActionLoading}
                                    onClick={() => {
                                        markCompleted(selectedRecord.AppID);
                                        document.querySelector('[data-bs-dismiss="modal"]').click();
                                    }}
                                >
                                    Mark as Completed
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};

export default connect(mapStateToProps, null)(StudentIdCardReport);
